<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>

      <input
          :type="type"
          class="form-control"
          :class="getClasses(size, valid)"
          :name="name"
          :id="id"
          :value="modelValue"
          :placeholder="placeholder"
          :isRequired="isRequired"
          @input="$emit('update:modelValue', $event.target.value)"
          @blur="blurAction"
      />

      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "argon-input",
  props: {
    modelValue: String,
    size: {
      type: String,
      default: "default",
    },
    valid: {
      type: Boolean,
      default: false,
    },
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    placeholder: String,
    type: String,
    isRequired: Boolean,
    blurAction: Function,
  },
  methods: {
    getClasses: (size, valid) => {
      let sizeValue = size ? `form-control-${size}` : null;
      let isValidValue = valid ? `${valid}` : "invalid";
      return `${sizeValue} ${isValidValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
  },
};
</script>